import React, { useState, useEffect } from "react";
import {Select, FormControl, InputLabel,MenuItem,Button, Dialog, DialogContent, IconButton, TextField, Typography, Stack, } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";

const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;

const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const OlympiadDateModal = ({ onClose, fetchData, propData }) => {
  const [loading, setLoading] = useState(false);
  const [examDate, setExamDate] = useState("");
  const [lastRegistrationDate, setLastRegistrationDate] = useState("");
  const [registrationFee, setRegistrationFee] = useState("");
  const [description, setDescription] = useState("");
  const [olympiadTypes, setOlympiadTypes] = useState([]);
  const [olympiadType, setOlympiadType] = useState("");

  useEffect(()=>{
    getAllOlympiadTypes()
  },[])

  useEffect(() => {
    if (propData) {
      // Convert ISO string to "YYYY-MM-DD" for date input
    //   setExamDate(propData.exam_date ? propData.exam_date.substring(0, 10) : "");
setExamDate(propData.exam_date ? new Date(propData.exam_date).toLocaleDateString("en-CA") : "");
      setLastRegistrationDate(
        propData.last_registration_date
          ? propData.last_registration_date.substring(0, 10)
          : ""
      );
      setRegistrationFee(propData.registration_fee || "");
      setDescription(propData.description || "");
      setOlympiadType(propData?.olympiad_type || "")
    }
  }, [propData]);

  async function getAllOlympiadTypes() {
        try {
            setLoading(true);
            const response = await window.Platform.database.getAllOlympiadTypes();
            if (response?.status) {
                setOlympiadTypes(response?.data)
            }
            else {
                window.NotificationUtils.showError(response?.message || "Olympiad types dropdown response error")
            }
        } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
        } finally {
            setLoading(false);
        }
  }

  const submitHandler = async () => {
    if(!olympiadType){
       window.NotificationUtils.showError("Please Select Olympiad Type");
      return;
    }
    if (!examDate) {
      window.NotificationUtils.showError("Please select an Exam Date");
      return;
    }
    if(!registrationFee){
      window.NotificationUtils.showError("Please Enter Registration Fee");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        exam_date: examDate,
        last_registration_date: lastRegistrationDate,
        registration_fee: registrationFee,
        description: description,
        olympiad_type : olympiadType
      };

      if (propData) {
        await window.Platform.database.updateOlympiadDate({
          ...payload,
          id: propData.id,
        });
        window.NotificationUtils.showSuccess("Olympiad Date updated successfully");
      } else {
        await window.Platform.database.addOlympiadDate(payload);
        window.NotificationUtils.showSuccess("Olympiad Date saved successfully");
      }

      fetchData();
      onClose();
    } catch (err) {
      window.NotificationUtils.showError(err?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog disableEnforceFocus maxWidth="sm" fullWidth open>
      <StyledDialogContent>
        <ModalHeaderContainer>
          <Typography variant="h5">
            {propData ? "Update Olympiad Date" : "Add Olympiad Date"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseOutlined />
          </IconButton>
        </ModalHeaderContainer>

        {loading && <OpaqueLoading />}

        <Stack gap={2} padding={2}>
          <FormControl size="small" fullWidth>
            <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Olympiad Type</InputLabel>
            <Select
              value={olympiadType}
              label="Select Olympiad Type"
              size="small"
              onChange={(e) => { setOlympiadType(e.target.value) }}
            >
              {olympiadTypes.map((type) => (
                <MenuItem key={type} value={type.id} sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}>{type.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Exam Date"
            type="date"
             sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
            value={examDate}
            onChange={(e) => setExamDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Registration Fee"
            type="number"
             sx={{ color: "black", fontSize: "13px", fontWeight: "500" }}
            value={registrationFee}
            onChange={(e) => setRegistrationFee(e.target.value)}
            fullWidth
            inputProps={{ min: 0 }}
          />
{/* 
          <TextField
            label="Last Registration Date"
            type="date"
            value={lastRegistrationDate}
            onChange={(e) => setLastRegistrationDate(e.target.value)}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
          <TextField
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={3}
          /> */}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              color="primary"
              variant="contained"
              onClick={submitHandler}
              // disabled={!examDate}
            >
              {propData ? "Update" : "Create"}
            </Button>
          </div>
        </Stack>
      </StyledDialogContent>
    </Dialog>
  );
};

export default OlympiadDateModal;